<script lang="ts" setup>

definePageMeta({title: 'Eventos'});
const breadcrumbData = [{
  title: 'Home',
  link: '/',
  subitems: [{title: 'Listar Eventos'}]
}]
</script>
<template>
  <EventList :breadcrumbData="breadcrumbData"/>
</template>
